import {EditableLabel} from 'shells/editable-label/editable-label';

import {DataFieldWrapper} from './data-field-wrapper';

import styles from './editable-label-field.module.css';

interface Props {
    label: string;
    value: string;
    editValue: string;
    placeholder: string;
    tooltip: string;
    onSaveNewValue: (value: string) => Promise<any>;
}

export function EditableLabelField(props: Props) {
    return (
        <DataFieldWrapper
            label={props.label}
            children={
                <div className={styles['label-field-container']}>
                    <EditableLabel
                        value={props.value}
                        editValue={props.editValue}
                        onSaveNewValue={props.onSaveNewValue}
                        placeholder={props.placeholder}
                        allowSavingEmpty={false}
                        shouldAllowUndo={false}
                        shouldTruncate={true}
                        tooltip={props.tooltip}
                        variant='header'
                    />
                </div>
            }
        />
    );
}
